<template>
  <div class="optin-field">
    <label :for="field.id">{{ field.label[currentLanguage] }} <span v-if="field.required" class="required">*</span></label>
    <label :for="field.id" class="control checkbox">
      <input :name="field.name" @change="$emit('input', $event.target.checked)" type="checkbox" :id="field.id" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)" :multiple="field.multi" :required="field.required">
      <span class="control-indicator"></span>
    </label>
    <span class="control-label" v-html="field.description[currentLanguage]"></span>
  </div>
</template>

<script>
export default {
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
}
</script>


// WEBPACK FOOTER //
// src/components/elements/optin.vue